import React, { useMemo, useRef } from 'react';
import {useDrag, useDrop} from 'react-dnd';
import CommandTemplate from './OperationTemplates/commandTemplate';
import {containsUnique} from './OperationTemplates/commandMap';
import Panel from '../../layout/Panel';
import Spacer from '../../layout/Spacer';
import {TrashIcon} from '../../Iconset';
import {DndItemTypes, LayoutOrientations} from '../../../globals';
import PropertyGroup from '../../properties/PropertyGroup';
import {StoreActions} from '../../../state/store';
import { useTypedDispatch, useTypedSelector } from '../../../state/hooks';

interface IRevisionOperationProps
{
	file: string;
	index: number;
	operations: any[];
	onNodeSelection?: (operation: any) => void;
}

export default function RevisionOperation(props: IRevisionOperationProps)
{
	const dispatch = useTypedDispatch();
	const operation = useTypedSelector(state => state.revisionModule.operations[props.file])[props.index];
	const flattenedConfig = useTypedSelector(state => state.userModule.sessionInfo?.serverOptions.flattenedConfig);

	const style = {
		padding: "0.1rem 0.3rem",
		marginBottom: ".2rem",
		cursor: "move"
	};

	const uniqueGroup = useMemo(() =>
	{
		if(!flattenedConfig) return "";

		const uniques = containsUnique(props.operations);
		for (const unique of uniques)
		{
			if (flattenedConfig.uniqueGroups[unique]?.includes(operation.command))
			{
				return unique;
			}
		}
		return "";
	}, [props.operations, operation, flattenedConfig]);

	const ref = useRef(null);
	const [, drop] = useDrop({
		accept: DndItemTypes.REVISION_OPERATION_ITEM,
		hover(item: any, monitor)
		{
			if (!ref.current)
			{
				return
			}
			const dragIndex = item.index;
			const hoverIndex = props.index;

			if (dragIndex === hoverIndex)
			{
				return
			}
			dispatch(StoreActions.revision.moveItem({ file: props.file, operationIndex: dragIndex, index: hoverIndex }));
			item.index = hoverIndex;
		},
		drop(item, monitor)
		{
			if (!ref.current)
			{
				return
			}
			const dragIndex = item.index
			const dropIndex = props.index;

			dispatch(StoreActions.revision.moveItem({ file: props.file, operationIndex: dragIndex, index: dropIndex }));
		}
	});
	const [{ isDragging }, drag] = useDrag({
		type: DndItemTypes.REVISION_OPERATION_ITEM,
		item: {
			index: props.index
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	})

	const opacity = isDragging ? 0 : 1
	drag(drop(ref));

	//render
	return flattenedConfig && (
		<div ref={ref} style={{ ...style, opacity }} >
			<PropertyGroup
				title={(operation.command !== '' ? flattenedConfig.commandList[operation.command] ? flattenedConfig.commandList[operation.command] : "Operation" : "Operation") + (uniqueGroup ? " (UNIQUE - " + uniqueGroup + ")" : "")}
				headerStyle={uniqueGroup ? { color: '#f77607' } : undefined}
				decorators={<TrashIcon scale={0.75}
									   data-name="delete"
									   onClick={() => { dispatch(StoreActions.revision.removeItem({ file: props.file, operationIndex: props.index })); }} />}
			>
				<Panel orientation={LayoutOrientations.Horizontal}>
					<Spacer size={{ x: "10px" }} />
					<Panel style={{
						width: "80%",
						margin: '5px',
						background: 'grey',
						borderRadius: "3px",
						color: 'black',
						padding: '5px'
					}}>
						<CommandTemplate {...props} operation={operation} operations={props.operations} onChangeCallback={() =>
						{
							if (props.onNodeSelection)
							{
								props.onNodeSelection(operation);
							}
						}} />
					</Panel>
				</Panel>
			</PropertyGroup>
		</div>
	);
}